import { ROL_TYPE } from '../utils/enums'

export function convertToMoney(price) {
    return Intl.NumberFormat("de-DE").format(price)
}

/**
 * ENI-212 — Muestra una fecha de evento en la HORA DEL LOCAL, sin importar cómo tenga
 * configurado el reloj la máquina del operador.
 *
 * El backend la manda con offset ('2026-09-15T14:00:00-03:00'), que es lo correcto para
 * comparar. Pero pasarla por `new Date()` y formatearla con getters locales la convierte a la
 * zona del navegador: una notebook mal configurada, o alguien mirando el backoffice de viaje,
 * vería la hora corrida. Como el string ya trae los dígitos del local, se leen directo.
 */
const WALL_CLOCK_RE = /^(\d{4})-(\d{2})-(\d{2})[T ](\d{2}):(\d{2})/;

export function formatEventDateTime(value) {
    if (!value) return '-';
    const m = WALL_CLOCK_RE.exec(String(value));
    if (!m) return String(value);
    return `${m[3]}/${m[2]}/${m[1]} ${m[4]}:${m[5]}`;
}

// 'YYYY-MM-DD' → 'DD/MM/YYYY'. Misma regla que arriba (leer los dígitos, no pasar por Date),
// para las fechas SIN hora: vigencias de membresía, jornadas. Vive acá y no en un módulo de
// dominio porque la usan la grilla de socios, el modal de venta y el de entradas.
export function formatYMD(value) {
    const m = /^(\d{4})-(\d{2})-(\d{2})/.exec(String(value || ''));
    return m ? `${m[3]}/${m[2]}/${m[1]}` : (value || '—');
}

// 'set' y no 'sep': es la abreviatura de uso corriente en Uruguay.
const MONTHS_ES_SHORT = ['ene', 'feb', 'mar', 'abr', 'may', 'jun', 'jul', 'ago', 'set', 'oct', 'nov', 'dic'];

/**
 * Fecha compacta para la grilla de Ventas: '14/jul 00:17'.
 *
 * Mismo criterio que formatEventDateTime: el backend manda el literal de pared
 * ('2026-07-14 00:17:25') y se leen los dígitos DIRECTO. Pasarlo por `new Date()` lo
 * reinterpretaría en la zona del navegador y correría la hora — que es justo el bug que
 * tenía esta columna cuando mostraba la fecha en formato largo.
 */
export function formatSaleDateShort(value) {
    if (!value) return '-';
    const m = WALL_CLOCK_RE.exec(String(value));
    if (!m) return String(value);
    const monthLabel = MONTHS_ES_SHORT[Number(m[2]) - 1] || m[2];
    // Sin el año: en la operativa diaria son casi todas del año en curso y ocupa lugar.
    return `${m[3]}/${monthLabel} ${m[4]}:${m[5]}`;
}

export function getTextColorClass(role) {
    var classStr = "text-success";
    if (role == 1) {
        classStr = "text-success";
    } else if (role == 9) {
        classStr = "text-error";
    } else {
        classStr = "text-warning";
    } 
    return classStr;
}

export function getTextColorClassUsers(role) {
    var classStr = "text-success";
    if (role == 1) {
        classStr = "text-success";
    } else if (role == 2) {
        classStr = "text-warning";
    } else {
        classStr = "text-error";
    } 
    return classStr;
}

export function getRoleName(role) {
    if (role == ROL_TYPE.ROLE_ADMIN) {
        return "Administrador"
    } else if (role == ROL_TYPE.ROLE_MANAGER) {
        return "Encargado"
    } else if (role == ROL_TYPE.ROLE_FINANCE) {
        return "Finanzas"
    } else {
        return "Usuario"
    }
}

export function getTextColorClassShipping(status) {
    var classStr = "text-success";
    if (status == 4 || status == 6) {
        classStr = "text-warning";
    } else if (status == 9) {
        classStr = "text-error";
    } else {
        classStr = "text-success";
    } 
    return classStr;
}

export function getTextColorClassTicket(status) {
    var classStr = "text-success";
    if (status == 2) {
        classStr = "text-success";
    } else if (status == 9) {
        classStr = "text-error";
    } else {
        classStr = "text-warning";
    } 
    return classStr;
}

export function getTextColorClassStock(stock, minStock) {
    var classStr = "text-success";
    if (stock < minStock) {
        classStr = "text-danger";
    } else if (stock == minStock) {
        classStr = "text-warning";
    } 
    return classStr;
}

export function getTextColorClassGeneral(status) {
    let classStr = "text-success";
    if (status == 1 || status == 2 || status == 8) {
        classStr = "text-success";
    } else if (status == 9) {
        classStr = "text-error";
    } else if (status == 11) {
        classStr = "text-info";
    } else {
        classStr = "text-warning";
    } 
    return classStr;
}

export function getTextColorRestockingPayment(status) {
    var classStr = "text-success";
    if (status == 1) {
        classStr = "text-success";
    } else {
        classStr = "text-warning";
    } 
    return classStr;
}
// Un importe tipeado a mano: devuelve el número, o null si no es interpretable sin adivinar.
//
// El caso que importa es "12.500" — el importe copiado tal cual del papel. `parseInt` da 12 y
// `Number` da 12,5; ninguno es lo que el operador quiso, y desde ENI-32 este número es el que se
// le paga al proveedor y el que se asienta en caja. Ni siquiera `type="number"` lo salva: el
// navegador lo acepta como decimal válido y manda 12,5 sin decir nada.
//
// Espeja `normalizarImporte` de backend/src/controllers/RestockingController.js: ante la
// ambigüedad se RECHAZA y se le pide al usuario que lo escriba sin separador de miles.
export function normalizarImporte(valor) {
    if (valor == null || valor === '') return null;
    const texto = String(valor).trim().replace(/\s/g, '');
    if (/^\d{1,3}([.,]\d{3})+$/.test(texto)) return null;   // punto/coma como separador de MILES
    const numero = Number(texto.replace(',', '.'));
    return Number.isFinite(numero) && numero > 0 ? numero : null;
}
